<template>
    <q-page>
     <div class="q-pa-md">
     <div class="text-h4">Periodo Vacacional</div>
    <q-table 
    dense
    :pagination="{rowsPerPage: 10}"
    :rows-per-page-options="[0]"
    virtual-scroll
    flat
    bordered
    :rows="periodos"
    separator="cell">
       <template v-slot:header>
      <q-tr class="bg-dark text-white">
            <q-th key="Descripcion"  align="left">Descripción</q-th>
            <q-th auto-width key="FechaIni" align="left">Fecha Inicial</q-th>
            <q-th auto-width key="FechaFin" align="left">Fecha Final</q-th>
            <q-th auto-width key="Actions" align="center">   
                <q-btn icon="add" color="dark" size="sm" padding="5px 5px" @click="editPeriodo(0)"/>
            </q-th>
      </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr>
            <q-td>
                {{ props.row.Descripcion }}
            </q-td>
            <q-td>
                {{ formatDate(new Date(props.row.FechaIni)) }}
            </q-td>
             <q-td>
                {{ formatDate(new Date(props.row.FechaFin)) }}
            </q-td>
             <q-td>
               <q-btn-group>
                <!--<q-btn icon="edit" color="secondary" size="sm" padding="5px 5px" @click="editPeriodo(props.row.IdPeriodoVacacional)"/>-->
                <q-btn icon="delete" color="negative" size="sm" padding="5px 5px" @click="showHandPunch(props.row.IdPeriodoVacacional)"/>
            </q-btn-group>
            </q-td>
        </q-tr>
      </template>
      </q-table>
     </div>
    </q-page>

    <q-dialog v-model="edit" persistent>
     <q-card style="width: 700px; max-width: 80vw;">
        <q-toolbar class="bg-dark text-white">
          <q-toolbar-title>Periodo Vacacional</q-toolbar-title>
          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>
        <q-card-section>
            <q-form class="q-gutter-md" @submit.prevent="saveHandPunch">
              <q-input outlined  dense v-model="periodo.Descripcion" label="Descripción" :rules="hpRules"/>
              <q-input class="m-3"  outlined dense v-model="periodo.FechaIni" label="Fecha Inicial" mask="date" :rules="['date']">
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="periodo.FechaIni" :locale="myLocale">
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Close" color="primary" flat />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>

               <q-input class="m-3"  outlined dense v-model="periodo.FechaFin" label="Fecha Final" mask="date" :rules="['date']">
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="periodo.FechaFin" :locale="myLocale">
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Close" color="primary" flat />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>

              
              <div>
              <div class="q-pa-md q-gutter-sm float-right">
                    <q-btn color="secondary" text-color="white" label="Cerrar" @click="edit=false"/>
                    <q-btn color="primary" label="Guardar" type="submit"/>
                </div>
              </div>
            </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model='del' persistent>
     <q-card style="width: 700px; max-width: 80vw;">
     <!--<q-card style="min-width: 80%; min-height:80%;">-->
        <q-toolbar class="bg-dark text-white">
          <q-toolbar-title>¿Está seguro de eliminar el Periodo Vacacional?</q-toolbar-title>
          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>
        <q-card-section>
            <q-form class="q-gutter-md" @submit.prevent="delHandPunch">
              <q-input outlined disable  dense v-model="periodo.Descripcion" label="Descripción" :rules="hpRules"/>
              <q-input outlined disable dense v-model="periodo.FechaIni" label="Fecha Inicial" :rules="hpRules"/>
              <q-input outlined disable dense v-model="periodo.FechaFin" label="Fecha Final" :rules="hpRules"/>
              
              <div>
              <div class="q-pa-md q-gutter-sm float-right">
                    <q-btn color="secondary" text-color="white" label="Cerrar" @click="del=false"/>
                    <q-btn color="primary" label="Eliminar" type="submit"/>
                </div>
              </div>
            </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>
</template>

<script>
import http from "@/services/http"

export default {
data: () => ({
  periodos:[],
  periodo:{},
      tipos:[{idtipo:1, Descripcion:"Face Station"},{idtipo:2, Descripcion:"Hand Punch"}],
      edit:false,
      del:false,
      hpRules: [v => !!v || 'Campo obligatorio',],
       myLocale: {
            days: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
            daysShort: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb'.split('_'),
            months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
            monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
            firstDayOfWeek: 1
        },
    }),
    methods:{
        async initialize(){
             this.periodos = await http.get('catalogos/periodovacacional');
        },
        async editPeriodo(id){
            if(id===0){
                this.periodo = { IdPeriodoVacacional: 0, Descripcion: '', FechaIni: this.getFecha(new Date()), FechaFin: this.getFecha(new Date()) }
            }
            else{
                this.periodo = await http.get(`catalogos/periodovacacional/${id}`)
            }
            this.edit=true
        },
        async showHandPunch(id){
          this.periodo = await http.get(`catalogos/periodovacacional/${id}`)
          this.del=true
        },
        async saveHandPunch(){
            await http.post('catalogos/periodovacacional',this.periodo);
            this.edit =false
            this.initialize();
        },
        async delHandPunch(){
            await http.delete(`catalogos/delperiodovacacional/${this.periodo.IdPeriodoVacacional}`)
            this.del =false
            this.initialize();
        },
          formatDate(date) {
            return [
                date.getDate().toString().padStart(2, '0'),
                (date.getMonth() + 1).toString().padStart(2, '0'),
                date.getFullYear(),
            ].join('/');
        },
         getFecha(fecha) {
            return fecha.getFullYear() + '/' + String(fecha.getMonth() + 1).padStart(2, '0') + '/' + String(fecha.getDate()).padStart(2, '0');
        },
    },
    created(){
        this.initialize();
    },
}
</script>